import React from 'react';
import { Box, Typography, Button, CssBaseline } from '@mui/material';

function ErrorFallback({ error, resetErrorBoundary }) {
  return (
    <>
      <CssBaseline />
      <Box
        sx={{
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: '4.8rem',
          bgcolor: 'background.default',
        }}
      >
        <Box
          sx={{
            bgcolor: 'background.paper',
            border: 1,
            borderColor: 'divider',
            borderRadius: 2,
            p: '4.8rem',
            flex: '0 1 96rem',
            textAlign: 'center',
          }}
        >
          <Typography variant="h4" fontWeight={600} sx={{ mb: 2 }}>
            Something went wrong
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
            {error.message}
          </Typography>
          <Button variant="contained" size="large" onClick={resetErrorBoundary}>
            Try again
          </Button>
        </Box>
      </Box>
    </>
  );
}

export default ErrorFallback;
